import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchPayrollOvertimeData } from 'queries/payroll/overtime/overtime'
import { PayrollFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function usePayrollOvertime({
    env,
    accessToken,
    location,
    filters,
}: PayrollFetchProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.PAYROLL_OVERTIME, location],
        () =>
            fetchPayrollOvertimeData({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
